export const SET_USER = "SET_USER";
export const FETCH_USER_LOGO = "FETCH_USER_LOGO";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER = "UPDATE_USER";
export const SET_PASSWORD_ATTEMPT = "SET_PASSWORD_ATTEMPT";
export const SET_CSRF_TOKEN = "SET_CSRF_TOKEN";
export const SET_LOADING = "SET_LOADING";
